import React from "react";
import { TERMS_CONTENT, TERMS_VERSION } from "../../legal/terms_v1.jsx";

export default function TermsModal({ open, onClose, onAccept, forceAccept = false }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[1500] flex items-center justify-center p-4 md:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="terms-title"
    >
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={forceAccept ? undefined : onClose}
      />
      <div
        className="relative z-10 w-full max-w-3xl rounded-3xl border border-white/10 bg-slate-900/80 backdrop-blur-xl shadow-2xl text-white max-h-[85vh] md:max-h-[80vh] flex flex-col overflow-hidden"
        style={{ boxShadow: "0 24px 60px rgba(0,0,0,0.55)" }}
      >
        <header className="px-5 py-4 md:px-7 md:py-6 border-b border-white/10">
          <div className="flex items-start justify-between gap-4">
            <div className="space-y-1">
              <p className="text-[11px] uppercase tracking-[0.2em] text-slate-400 mb-1">Legal</p>
              <h2 id="terms-title" className="text-xl md:text-2xl font-semibold text-slate-50">
                Terms &amp; Conditions
              </h2>
              <p className="text-xs text-slate-400">Version {TERMS_VERSION}</p>
            </div>
            {!forceAccept && (
              <button
                className="rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-sm text-slate-100 hover:bg-white/10 transition"
                onClick={onClose}
              >
                Close
              </button>
            )}
          </div>
          <div className="border-b border-white/10 mt-3" />
        </header>
        <div className="flex-1 overflow-y-auto px-5 py-4 md:px-7 md:py-6">
          <div className="max-w-[60ch] mx-auto space-y-4 text-slate-100 text-sm md:text-[15px] leading-relaxed">
            {TERMS_CONTENT}
          </div>
        </div>
        <footer className="border-t border-white/10 px-5 py-4 md:px-7 md:py-5">
          <div className="flex items-center justify-end gap-3">
          {!forceAccept && (
            <button
              className="rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm text-slate-100 hover:bg-white/10 transition"
              onClick={onClose}
            >
              Close
            </button>
          )}
          {onAccept && (
            <button
              className="rounded-full px-5 py-2 text-sm font-semibold text-black bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-400 hover:to-orange-500 shadow-[0_10px_30px_rgba(234,88,12,0.35)] transition"
              onClick={() => {
                try {
                  onAccept();
                } catch (err) {
                  console.error("[terms] accept error", err);
                }
              }}
            >
              I Agree
            </button>
          )}
          </div>
        </footer>
      </div>
    </div>
  );
}
